import { useAuthListener } from 'app/hooks/useAuthListener';
import assert from 'assert';
import React, { createContext, useContext } from 'react';
import { AuthService } from 'services/AuthService';

const AuthContext = createContext<{
  isAuthenticated: boolean;
  service: AuthService;
} | null>(null);

interface Props {
  children: React.ReactNode;
  service: AuthService;
}

export function AuthProvider({ children, service }: Props) {
  const isAuthenticated = useAuthListener(service);

  const value = {
    isAuthenticated,
    service,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

const useAuth = () => {
  const context = useContext(AuthContext);
  assert(context);
  return context;
};

export default useAuth;
